import React, { useState } from 'react';
import { translations, formatString } from '../translations';
import Timeline from './Timeline';
import Settings from './Settings';
import Account from './Account';
import Layout from './Layout';

function Welcome({ patientData, onLogout, language = 'de' }) {
  const [activeTab, setActiveTab] = useState('timeline');
  const [hideHeader, setHideHeader] = useState(false);
  const t = translations[language] || translations.en;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(language === 'de' ? 'de-DE' : 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="welcome-container">
      <Layout hideHeader={hideHeader}>
        {/* Panneaux montés en permanence, affichage basculé */}
        <div style={{ display: activeTab === 'timeline' ? 'block' : 'none' }}>
          <Timeline 
            language={language} 
            patientData={patientData} 
            onHeaderVisibilityChange={setHideHeader}
            isActive={activeTab === 'timeline'}
          />
        </div>
        <div style={{ display: activeTab === 'account' ? 'block' : 'none' }}>
          <Account 
            patientData={patientData} 
            language={language}
            isActive={activeTab === 'account'}
          />
        </div>
        <div style={{ display: activeTab === 'settings' ? 'block' : 'none' }}>
          <Settings 
            onLogout={onLogout} 
            language={language}
            isActive={activeTab === 'settings'}
          />
        </div>
        
        {/* Bottom Navigation Bar */}
        <nav className="bottom-nav">
          <div 
            className={`nav-item ${activeTab === 'timeline' ? 'active' : ''}`}
            onClick={() => setActiveTab('timeline')}
          >
            <img src="/images/calendar.png" alt="Timeline" className="nav-icon" />
          </div>
          <div 
            className={`nav-item ${activeTab === 'account' ? 'active' : ''}`}
            onClick={() => setActiveTab('account')}
          >
            <img src="/images/user_icon.png" alt="Account" className="nav-icon" />
          </div>
          <div 
            className={`nav-item ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            <img src="/images/setting.png" alt="Settings" className="nav-icon" />
          </div>
        </nav>
      </Layout>
    </div>
  );
}

export default Welcome; 